"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _SvgIcon = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _styles = require("@mui/material/styles");
var _AttachFile = _interopRequireDefault(require("@mui/icons-material/AttachFile"));
var _Beenhere = _interopRequireDefault(require("@mui/icons-material/Beenhere"));
var _Create = _interopRequireDefault(require("@mui/icons-material/Create"));
var _Delete = _interopRequireDefault(require("@mui/icons-material/Delete"));
var _Description = _interopRequireDefault(require("@mui/icons-material/Description"));
var _History = _interopRequireDefault(require("@mui/icons-material/History"));
var _IndeterminateCheckBox = _interopRequireDefault(require("@mui/icons-material/IndeterminateCheckBox"));
var _Lock = _interopRequireDefault(require("@mui/icons-material/Lock"));
var _MoveToInbox = _interopRequireDefault(require("@mui/icons-material/MoveToInbox"));
var _PinDrop = _interopRequireDefault(require("@mui/icons-material/PinDrop"));
var _Replay = _interopRequireDefault(require("@mui/icons-material/Replay"));
var _VisibilityOff = _interopRequireDefault(require("@mui/icons-material/VisibilityOff"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StyledIconButton = (0, _styles.styled)(_IconButton.default)({
  color: '#000000'
});
const icons = {
  delete: /*#__PURE__*/_react.default.createElement(_Delete.default, null),
  detail: /*#__PURE__*/_react.default.createElement(_Description.default, null),
  beenhere: /*#__PURE__*/_react.default.createElement(_Beenhere.default, null),
  replay: /*#__PURE__*/_react.default.createElement(_Replay.default, null),
  indeterminate: /*#__PURE__*/_react.default.createElement(_IndeterminateCheckBox.default, null),
  visibilityOff: /*#__PURE__*/_react.default.createElement(_VisibilityOff.default, null),
  select: /*#__PURE__*/_react.default.createElement(_SvgIcon.default, null, /*#__PURE__*/_react.default.createElement("g", {
    id: "Bounding_Box"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  })), /*#__PURE__*/_react.default.createElement("g", {
    id: "Master"
  }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("polygon", {
    points: "15.5,5 11,5 16,12 11,19 15.5,19 20.5,12 \t\t"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    points: "8.5,5 4,5 9,12 4,19 8.5,19 13.5,12 \t\t"
  })))),
  history: /*#__PURE__*/_react.default.createElement(_History.default, null),
  update: /*#__PURE__*/_react.default.createElement(_SvgIcon.default, null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z"
  })),
  password: /*#__PURE__*/_react.default.createElement(_Lock.default, null),
  register: /*#__PURE__*/_react.default.createElement(_Create.default, null),
  setPost: /*#__PURE__*/_react.default.createElement(_MoveToInbox.default, null),
  upload: /*#__PURE__*/_react.default.createElement(_AttachFile.default, null),
  location: /*#__PURE__*/_react.default.createElement(_PinDrop.default, null)
};

/**
 * 一覧表示内のボタン
 * @props {string} action - アイコンのアクション
 * @props {func} [onClick] - クリックイベント<br/>
 * シグネチャ： ():void
 */
const ListIconButton = props => {
  const {
    className,
    action,
    onClick
  } = props;
  return /*#__PURE__*/_react.default.createElement(StyledIconButton, {
    className: className,
    onClick: onClick
  }, icons[action]);
};
ListIconButton.propTypes = {
  action: _propTypes.default.oneOf(['delete', 'detail', 'select', 'history', 'update', 'password', 'register', 'setPost', 'upload', 'location', 'beenhere', 'replay', 'indeterminate', 'visibilityOff']).isRequired,
  onClick: _propTypes.default.func
};
var _default = exports.default = ListIconButton;